import { useContext, useEffect } from "react"
import { Outlet } from "react-router"
import { useCounter } from "../app/hooks"
import { setCounter } from "../app/slices/counterSlice"
import { store } from "../app/store"
import ScrollToTop from "../components/ScrollToTop/ScrollToTop"
import AuthContext from "../providers/AuthProvider"

const RootLayout = () => {
  const authContext = useContext(AuthContext)
  const { value: counter } = useCounter()

  useEffect(() => {
    if (counter === null) return

    if (counter <= 0) {
      authContext.logout()
      return
    }

    const timer = setInterval(() => {
      store.dispatch(setCounter())
    }, 1000)

    return () => {
      clearInterval(timer as any)
    }
  }, [counter, authContext])

  return (
    <>
      <ScrollToTop />
      <Outlet />
    </>
  )
}

export default RootLayout
